module.exports = __webpack_public_path__ + "media/images/category/dummy/bottoms06-0ddeb1c36f796211b544e2edc5a18653.jpg";